{
  "principal": 250000,
  "payment": 12000,
  "cycleSeconds": 2100,
  "ratePerCycle": 0.02,
  "lateFee": 2000,
  "rateStepOnMiss": 0.01,
  "rateCap": 0.05,
  "repoAfterMissed": 2,
  "repoFee": 5000,
  "rebuild": { "base": 15000, "moduleValueShare": 0.05 },
  "insurance": { "premiumPerCycle": 1500, "insuredFeeMult": 0.5 },
  "debtPaymentPerCycle": 12000,
  "historyLimit": 100,
  "office": {
    "statement": {
      "issuer": "Tethys Crew Finance · lease statement",
      "signedBy": { "name": "Maren Voss", "role": "Chief Executive, Tethys Mining Combine" }
    },
    "covenant": {
      "title": "Lessee Conduct Covenant",
      "clauses": [
        "1. Working operation. The lessee keeps the vessel in working operation and files its extraction returns with the lessor.",
        "2. Extraction. The lessee works the vessel to the fullest extraction it can bear. Each tonne delivered to a lessor refinery is credited at the posted price and earns the extraction incentive of Charter §9.",
        "3. Recall. The lessor may recall the vessel, without notice, for any conduct that does the lessor reputational harm.",
        "4. Telemetry. The vessel's transponder reports to the lessor for the life of the lease. Tampering with it is a breach.",
        "5. Recovery. A recalled or defaulted vessel is collected by Tethys Asset Recovery. Recovery costs are added to the lessee's account."
      ],
      "reading": {
        "speaker": "Ines Duarte, registry clerk",
        "text": "Registry desk, Duarte. I have to read you the Covenant before you sign; it's the rule. Clause three: the lessor may recall the vessel, without notice, for any conduct that does the lessor reputational harm. That's the one people ask about. Sign at the bottom."
      }
    },
    "recovery": {
      "crew": "Tethys Asset Recovery",
      "liveryTag": "TETHYS ASSET RECOVERY",
      "marks": ["mark_tethys_hex", "mark_tcf_l"]
    }
  }
}
